import { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import VerifyOtpForm from './VerifyOtpForm'; // Import your OTP component
import { userRegistration } from '../services/authService';
import { toast } from 'react-toastify';
const CreateUserForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    role: ''
  });

  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await userRegistration(formData); // Replace with your actual API

      if (response.status === 200) {
           toast.success('OTP Sent successfully!');
        setShowOtpScreen(true);
      } else {
        setError('Failed to create user or send OTP.');
      }
    } catch (err) {
      console.error(err);
      setError('Something went wrong!');
    }
  };

  if (showOtpScreen) {
    return <VerifyOtpForm email={formData.email} />;
  }

  return (
    <div>
      <h2>Create User</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            name="email"
            onChange={handleChange}
            value={formData.email}
            required
          />
        </Form.Group>

        <Form.Group controlId="formPassword" className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter password"
            name="password"
            onChange={handleChange}
            value={formData.password}
            required
          />
        </Form.Group>

        <Form.Group controlId="formRole" className="mb-3">
          <Form.Label>Role</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter role"
            name="role"
            onChange={handleChange}
            value={formData.role}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit">Send OTP</Button>
      </Form>
    </div>
  );
};

export default CreateUserForm;
